import { ReactElement } from 'react';
import styled from 'styled-components';

import { Box, Grid } from '@breathelife/mui';
import { PdfDocumentTitle, PdfPaddedGrid } from '@breathelife/ui-components';
import { ParticipantRole } from '@zinnia/form-engine-sdk';

import usePdfContext from '../../../../Context/usePdfContext';
import { translate } from '../../../../Localization/Localizer';
import { ESignature } from './ESignature';

const SignatureContainer = styled.div`
  & {
    break-inside: avoid;
  }
`;

export function ESignatureContainer(): ReactElement | null {
  const { application, signatureData } = usePdfContext();
  const { lang: language } = application;

  if (typeof signatureData === 'undefined') {
    return null;
  }

  const { signers, eSignatureFieldType } = signatureData;

  return (
    <Box mb={3}>
      <SignatureContainer>
        <PdfDocumentTitle>{translate('signature.header', { locale: language })}</PdfDocumentTitle>
        <PdfPaddedGrid container spacing={3}>
          {(Object.keys(signers) as Array<ParticipantRole>).map((role) => {
            const signersWithRole = signers[role];

            return (
              signersWithRole &&
              signersWithRole.length > 0 && (
                <Grid key={role} item xs={3}>
                  <ESignature signeeType={role} fieldType={eSignatureFieldType} />
                </Grid>
              )
            );
          })}
        </PdfPaddedGrid>
      </SignatureContainer>
    </Box>
  );
}
